import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { SimpleErrorResponse } from '@/models/Error';

import { machineMigrationOpportunityOptInPath } from './machineMigrationOpportunityOptInPath';
import { machineMigrationOpportunityQueryKey } from './useMachineMigrationOpportunitiesShow';

export type SkipReason = 'machine_type_mismatch' | 'bitrise_yml_in_repo' | 'workflow_not_found';

type Request = { workflow: string };
type Response = { skippedWithReason?: SkipReason };

const useMachineMigrationOpportunitiesOptIn = (
  appSlug: string,
  onSuccess: ({ skippedWithReason, workflow }: { skippedWithReason?: SkipReason; workflow: string }) => void,
) => {
  const queryClient = useQueryClient();

  const [workflow, setWorkflow] = useState<string | null>(null);

  const { mutate, ...rest } = useMonolithApiMutation<Response, SimpleErrorResponse, Request>(
    machineMigrationOpportunityOptInPath(appSlug),
    'PATCH',
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries({ queryKey: machineMigrationOpportunityQueryKey(appSlug) });
        onSuccess({ skippedWithReason: data.data.skippedWithReason, workflow: variables.workflow });
        setWorkflow(null);
      },
    },
  );

  return {
    mutate: ({ workflow }: { workflow: string }) => {
      setWorkflow(workflow);
      mutate({ workflow });
    },
    targetWorkflow: workflow,
    ...rest,
  };
};

export default useMachineMigrationOpportunitiesOptIn;
